<template>
  <v-dialog
    v-model="open"
    max-width="630"
    content-class="sc-modal sc-modal--md"
    scrollable
  >
    <v-card v-if="open" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-pencil</v-icon>
        <div>
          <span class="sc-modal__title">Editar produção</span>
          <span class="sc-modal__subtitle">{{ nome_producao || sig_producao }} · {{ sig_producao }}</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <v-form @submit.prevent="atualizarProducao" id="form-alterar-producao">
          <div class="sc-modal__field">
            <label class="sc-modal__field-label">Nome *</label>
            <v-text-field
              solo flat dense
              hide-details="auto"
              v-model="nome_producao"
              :rules="rules.required"
              maxlength="40"
              counter="40"
              background-color="surface_tertiary"
              placeholder="Ex: Bom dia São Paulo"
            />
          </div>

          <div class="sc-modal__field">
            <label class="sc-modal__field-label">Sigla</label>
            <v-tooltip bottom color="surface_neutral_selected">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  solo flat dense
                  hide-details
                  v-model="sig_producao"
                  background-color="surface_tertiary"
                  readonly
                  append-icon="mdi-lock"
                />
              </template>
              <span>Não é permitido editar a sigla da produção</span>
            </v-tooltip>
          </div>

          <div v-if="pracas" class="sc-modal__field">
            <label class="sc-modal__field-label">Praça</label>
            <v-select
              v-model="cod_praca"
              :items="pracas"
              placeholder="Selecione a praça"
              item-text="sig_praca"
              item-value="cod_praca"
              return-object
              @change="(e) => (cod_praca = Number(e.cod_praca))"
              solo flat dense
              hide-details
              background-color="surface_tertiary"
            />
          </div>

          <div class="sc-modal__field">
            <label class="sc-modal__field-label">Descrição</label>
            <v-textarea
              solo flat dense
              hide-details
              v-model="dsc_producao"
              background-color="surface_tertiary"
              no-resize
              rows="3"
              placeholder="Descrição opcional da produção"
            />
          </div>

          <div class="sc-modal__field">
            <label class="sc-modal__field-label">Dias de retenção</label>
            <v-slider
              v-model="qtde_dias_retencao"
              hide-details
              min="1"
              max="7"
              dense
              thumb-label
              thumb-color="primary"
              ticks="always"
              :tick-labels="ticksLabels"
            />
          </div>

          <div class="producao-toggles">
            <label class="sc-modal__field-label">Funcionalidades</label>
            <div class="producao-toggle-list">
              <div class="producao-toggle-item">
                <div class="producao-toggle-info">
                  <span class="producao-toggle-name">Colaboração avulsa</span>
                  <span class="producao-toggle-desc">Envio direto pelo SocialCam</span>
                </div>
                <v-switch v-model="novaColaboracao" color="primary" hide-details dense class="mt-0 pt-0" />
              </div>
              <div class="producao-toggle-item">
                <div class="producao-toggle-info">
                  <span class="producao-toggle-name">Receber retweets</span>
                </div>
                <v-switch v-model="receberRetweets" color="primary" hide-details dense class="mt-0 pt-0" />
              </div>
              <div class="producao-toggle-item">
                <div class="producao-toggle-info">
                  <span class="producao-toggle-name">Mosaico de colaborações</span>
                  <span class="producao-toggle-desc">Exibição em tela cheia</span>
                </div>
                <v-switch v-model="mosaicoEnabled" color="primary" hide-details dense class="mt-0 pt-0" />
              </div>
              <div class="producao-toggle-item">
                <div class="producao-toggle-info">
                  <span class="producao-toggle-name">Tarja de colaboração</span>
                  <span class="producao-toggle-desc">Fundo verde para exibição ao vivo</span>
                </div>
                <v-switch v-model="tarjaEnabled" color="primary" hide-details dense class="mt-0 pt-0" />
              </div>
              <div class="producao-toggle-item">
                <div class="producao-toggle-info">
                  <span class="producao-toggle-name">Tarja de cronômetro</span>
                  <span class="producao-toggle-desc">Cronômetro em fundo verde</span>
                </div>
                <v-switch v-model="tarjaCronometro" color="primary" hide-details dense class="mt-0 pt-0" />
              </div>
              <div class="producao-toggle-item">
                <div class="producao-toggle-info">
                  <span class="producao-toggle-name">Globo Graphics</span>
                  <span class="producao-toggle-desc">Cenas e playout Vizrt para esta produção</span>
                </div>
                <v-switch v-model="globographicsEnabled" color="primary" hide-details dense class="mt-0 pt-0" />
              </div>
            </div>
          </div>
        </v-form>
      </div>

      <div class="sc-modal__footer">
        <v-btn text @click="close()" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn color="primary" type="submit" form="form-alterar-producao" class="modal-btn-confirm">
          <v-icon small class="mr-1">mdi-check</v-icon>
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
export default {
  name: "EditarProducao",
  props: {
    fetchData: Function,
    modalData: Object,
    dialog: Boolean,
  },
  computed: {
    open: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  data() {
    return {
      ticksLabels: ["1", "2", "3", "4", "5", "6", "7"],
      sig_producao: "",
      nome_producao: "",
      cod_praca: null,
      qtde_dias_retencao: null,
      novaColaboracao: false,
      receberRetweets: false,
      tarjaEnabled: false,
      tarjaCronometro: false,
      mosaicoEnabled: false,
      globographicsEnabled: false,
      dsc_producao: "",
      cod_producao: "",
      pracas: [],
      rules: {
        required: [(value) => !!value || "Campo obrigatório."],
      },
    };
  },
  watch: {
    modalData() {
      this.seedFromModalData();
    },
    dialog(open) {
      if (open) this.seedFromModalData();
    },
  },
  created() {
    this.getPracas();
    this.seedFromModalData();
  },
  methods: {
    seedFromModalData() {
      const data = this.modalData || {};
      this.sig_producao = data.sig_producao || "";
      this.nome_producao = data.nome_producao || "";
      this.dsc_producao = data.dsc_producao || "";
      this.novaColaboracao = data.settings?.colaboracao?.nova_colaboracao ?? false;
      this.tarjaEnabled = data.settings?.tarja?.enabled ?? false;
      this.tarjaCronometro = data.settings?.tarja?.cronometro ?? true;
      this.mosaicoEnabled = data.settings?.mosaico?.enabled ?? false;
      this.globographicsEnabled = data.settings?.globographics?.enabled ?? false;
      this.cod_producao = data.cod_producao || "";
      this.cod_praca = data.cod_praca || "";
      this.dsc_login_producao = data.dsc_login_producao || "";
      this.receberRetweets = data.settings?.colaboracao?.receber_retweets ?? false;
      this.qtde_dias_retencao = data.qtd_dias_retencao_mensagens;
    },
    async getPracas() {
      try {
        const response = await apiClient.get("/listarPracas");
        this.pracas = response.data.pracas;
      } catch (error) {
        this.$toast.error("Erro ao buscar praças.");
      }
    },
    async atualizarProducao() {
      if (this.nome_producao.trim() === "") {
        this.$toast.error("Informe o nome da produção.");
        return;
      }
      try {
        const response = await apiClient.put(`/atualizarProducao/${this.cod_producao}`, {
          nome_producao: this.nome_producao.trim(),
          dsc_producao: this.dsc_producao,
          dsc_login_producao: this.dsc_login_producao,
          cod_praca: this.cod_praca,
          qtd_dias_retencao_mensagens: this.qtde_dias_retencao,
          settings: {
            colaboracao: {
              nova_colaboracao: !!this.novaColaboracao,
              receber_retweets: !!this.receberRetweets,
            },
            tarja: {
              enabled: !!this.tarjaEnabled,
              cronometro: !!this.tarjaCronometro,
            },
            mosaico: {
              enabled: !!this.mosaicoEnabled,
            },
            globographics: {
              enabled: !!this.globographicsEnabled,
            },
            enquete: {},
          },
        });
        if (response.status === 200) {
          this.$toast.success("Produção alterada com sucesso!");
        }
      } catch (error) {
        this.$toast.error("Erro ao alterar produção.");
      } finally {
        this.fetchData();
        this.close();
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.producao-toggles { margin-top: var(--sc-space-2); }
.producao-toggle-list { display: flex; flex-direction: column; gap: var(--sc-space-1); margin-top: var(--sc-space-2); }
.producao-toggle-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: var(--sc-space-2) var(--sc-space-3); background: var(--sc-surface-tint-subtle);
  border-radius: var(--sc-radius-md); transition: background var(--sc-duration-fast) var(--sc-easing-standard);
  &:hover { background: var(--sc-surface-tint-hover); }
}
.producao-toggle-info { display: flex; flex-direction: column; gap: var(--sc-space-1); }
.producao-toggle-name { font-size: var(--sc-text-base); font-weight: var(--sc-weight-medium); color: var(--v-text_primary-base); }
.producao-toggle-desc { font-size: var(--sc-text-sm); color: var(--v-text_secondary-base); }
::v-deep .v-input--switch { margin: 0; padding: 0; }
</style>
